<template>
<div class="specialPunchDialog">
    <el-dialog :title="item.customername+'的打卡数据'" :visible.sync="dialogVisible" width="560px" @close="cancel">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="punchdate" label="打卡日期" min-width="150px"></el-table-column>
            <el-table-column prop="punchtime" label="打卡时间" class-name="tc" label-class-name="tc"></el-table-column>
            <el-table-column prop="joinexamcount" label="参与试卷数" class-name="tc" label-class-name="tc"></el-table-column>
            <el-table-column prop="finishexamcount" label="完成试卷数" class-name="tc" label-class-name="tc"></el-table-column>
        </el-table>
        <el-pagination background @current-change="_getList" :current-page.sync="page.page" :page-size="page.pageSize"
                       :pager-count="11" layout="prev, pager, next" :total="total">
        </el-pagination>
    </el-dialog>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getQuestionbankuserpunchinfo} from 'api/questionApi'

export default {
    name: 'specialPunchDialog',
    data() {
        return {
            dialogVisible: false,
            tableData: [],
            item: {
                customername: ''
            },
            param: {
                examcode: this.$route.query.examcode,
                customerid: '',
            },
            page: {
                page: 1,
                pageSize: 10,
                pageCount: 0
            },
            total: 0
        }
    },
    mounted() {
    },
    methods: {
        cancel() {
            this.dialogVisible = false
        },
        openDialog(row) {
            this.item = row
            this.param.customerid = row.customerinnerid
            this.tableData = []
            this._getList()
            this.dialogVisible = true
        },
        _getList() {
            this.setLoading(true)
            getQuestionbankuserpunchinfo({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.specialPunchDialog {
    .tc {
        .cell {
            text-align: center;
        }
    }
}
</style>
